import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=4e5550d9"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"
import style0 from "./Delete.vue?vue&type=style&index=0&id=4e5550d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports